import { render, staticRenderFns } from "./po-obligation-list.vue?vue&type=template&id=6385c93a&"
import script from "./po-obligation-list.vue?vue&type=script&lang=js&"
export * from "./po-obligation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports